import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { AssistantBehaviourContent } from '@/pageContents/kiEinstellungen/AssistantBehaviourContent';
import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';

const AssistantBehaviour: PageWithLayout = () => (
    <>
        <Helmet>
            <title>Verhalten | Starjack Backoffice</title>
        </Helmet>
        <Box sx={{ p: 3 }}>
            <AssistantBehaviourContent />
        </Box>
    </>
);

AssistantBehaviour.isProtected = true;
AssistantBehaviour.getLayout = (Comp) => <SidebarLayout>{Comp}</SidebarLayout>;
AssistantBehaviour.permissions = [Permission.ADMIN];

export default AssistantBehaviour;
